import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';

const DeliverablesMetrics = ({ metrics = [], section = {} }) => {
  const theme = useTheme();
  const items = metrics.length > 0 ? metrics : [];

  return (
    <Box py={{ xs: 4, md: 6 }}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
        gutterBottom
        color="secondary"
        align="center"
      >
        {section.overline || 'Entregables'}
      </Typography>
      <Typography variant="h4" align="center" sx={{ fontWeight: 800, mb: 1 }}>
        {section.title || 'Volumen mensual'}
      </Typography>
      {section.description && (
        <Typography align="center" color="textSecondary" sx={{ maxWidth: 720, mx: 'auto', mb: 4 }}>
          {section.description}
        </Typography>
      )}

      <Grid container spacing={3}>
        {items.map((item) => (
          <Grid item xs={12} sm={6} md={3} key={item.label}>
            <Box
              textAlign="center"
              p={3}
              borderRadius={2}
              sx={{
                height: '100%',
                bgcolor: theme.palette.background.paper,
                boxShadow: theme.shadows[2],
              }}
            >
              <Typography variant="h3" color="primary" sx={{ fontWeight: 800 }}>
                {item.value}
                {item.suffix || ''}
              </Typography>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 1 }}>
                {item.label}
              </Typography>
              {item.subtitle && (
                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                  {item.subtitle}
                </Typography>
              )}
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

DeliverablesMetrics.propTypes = {
  metrics: PropTypes.array,
  section: PropTypes.object,
};

export default DeliverablesMetrics;
